export default __webpack_public_path__ + "static/media/apps.ba8088bb.svg";